import jQuery from 'jquery/dist/jquery';

// jQuery needs to be attached to the window before jQuery UI so it can be
// loaded safely
window.jQuery = jQuery;
window.$ = jQuery;
